import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, isNull } from "lodash";
import { Tooltip } from "@mui/material";
// Icons
import Icon from "@mdi/react";
import { mdiCog } from "@mdi/js";

// Components
import TableHead from "./TableHead";
import TableBody from "./TableBody";

// Redux
import {
  createCertifyFinancial,
  updateCertifyFinancialItem,
  createRejectedScopeList,
} from "../../../../../../redux/slices/utilsSlice";

const CeilingFlow = ({ showColumn, ceilingFlowRef, stages }) => {
  const dispatch = useDispatch();

  const [colSpan, setColSpan] = useState(0);
  const [matchCell, setMatchCell] = useState({});

  const [viewColumns, setViewColumns] = useState({
    dipohon: {
      key: "siling_dipohon",
      checked: true,
      disabled: false,
    },
    upen: {
      key: "siling_upen",
      checked: true,
      disabled: false,
    },
    jppn: {
      key: "siling_jppn",
      checked: true,
      disabled: false,
    },
  });

  const [showYears, setShowYears] = useState([]);

  const [newValues, setNewValues] = useState({
    id: null,
    amount: 0,
  });

  const { project, components, rmkActiveApplication } = useSelector(
    (state) => ({
      project: state.certifyReducer.project.data,

      components: state.utilsReducer.certifyFinancial,
      rmkActiveApplication: state.rmkReducer.rmkActiveApplication,
    }),
  );

  const years = [
    rmkActiveApplication.first_year,
    rmkActiveApplication.second_year,
    rmkActiveApplication.third_year,
    rmkActiveApplication.fourth_year,
    rmkActiveApplication.fifth_year,
  ];

  const groupedByYear = components
    ?.flatMap((obj) => obj?.ceiling_flow_details)
    ?.reduce((acc, item) => {
      const { year } = item;
      if (years.includes(year)) {
        if (!acc[year]) {
          acc[year] = [];
        }
        acc[year].push(item);
      }
      return acc;
    }, {});

  const result = years.map((year) => ({
    year: Number(year), // or `Number(year)` if you prefer numbers
    children: groupedByYear[year] || [], // default to empty array
  }));

  const handleEditAmount = (item, column) => {
    if (item.id === matchCell) {
      setMatchCell({});
      setNewValues({});
      return false;
    }

    setMatchCell({
      rowNum: item.id,
      columnNum: column,
    });

    if (!isEmpty(item)) {
      const findItem = components
        ?.flatMap((obj) => obj.ceiling_flow_details)
        ?.find((obj) => obj.id === item.id);
      setNewValues({
        id: findItem.id,
        amount: findItem.amount,
      });
    }
  };

  const handleShowAllYear = (years) => {
    const getAllYear = years.map((year) => Number(year));

    if (isEmpty(showYears)) {
      setShowYears(getAllYear);
    } else {
      setShowYears([]);
    }
  };

  const handleShow = (year) => {
    const isTrue = showYears.includes(year);

    if (isTrue) {
      setShowYears(showYears.filter((item) => Number(item) !== Number(year)));
    } else {
      setShowYears((item) => [...item, Number(year)]);
    }
  };

  const handleViewColumn = (e) => {
    const value = e.target.value;
    const column = viewColumns[value];
    setViewColumns({
      ...viewColumns,
      [value]: {
        ...column,
        checked: !column.checked,
      },
    });
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      const result = Object.values(showColumn).filter(
        (value) => value === true,
      ).length;
      setColSpan(result + 4);
    }
    return () => {
      isMounted = false;
    };
  }, [showColumn]);

  useEffect(() => {
    if (stages === "4") {
      setViewColumns({
        ...viewColumns,
        ["jppn"]: {
          checked: false,
          disabled: true,
        },
      });
    }

    return () => {};
  }, [stages]);

  return (
    <React.Fragment>
      <div className='mb-3' ref={ceilingFlowRef}>
        <div className='d-flex justify-content-between mb-2'>
          <h5>
            SENARAI SKOP PROJEK MENGIKUT ALIRAN SILING SEPANJANG TEMPOH RMK
          </h5>
          <div className='d-flex align-items-center' style={{ fontSize: 12 }}>
            <Tooltip title='Sembunyi kolum' placement='top' arrow>
              <Icon className='me-2' path={mdiCog} size={0.8} />
            </Tooltip>
            {Object.keys(viewColumns)
              .map((key) => ({ label: key, ...viewColumns[key] }))
              .map((item) => (
                <Form.Group
                  key={item.label}
                  className='me-3 text-uppercase'
                  controlId={viewColumns[item.label].key}
                >
                  <Form.Check
                    label={item.label}
                    value={item.label}
                    onChange={(e) => handleViewColumn(e)}
                    checked={viewColumns[item.label].checked}
                    disabled={viewColumns[item.label].disabled}
                  />
                </Form.Group>
              ))}
          </div>
        </div>

        <div className='table-responsive'>
          <Table bordered size='sm' style={{ fontSize: 11 }}>
            <TableHead
              showColumn={showColumn}
              project={project}
              showAllYear={handleShowAllYear}
              showYears={showYears}
              viewColumns={viewColumns}
            />
            <TableBody
              showColumn={showColumn}
              colSpan={colSpan}
              data={result}
              matchCell={matchCell}
              project={project}
              newValues={newValues}
              handleEditAmount={handleEditAmount}
              handleShow={handleShow}
              showYears={showYears}
              viewColumns={viewColumns}
            />
          </Table>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CeilingFlow;
